import React from "react";
import { MdMeetingRoom, MdCameraAlt } from "react-icons/md";
import "./RoomScanDialog.css";

const RoomScanDialog = ({ isOpen, onStart }) => {
  if (!isOpen) return null;

  return (
    <div className="room-scan-dialog-overlay">
      <div className="room-scan-dialog">
        <div className="room-scan-content">
          <div className="room-scan-icon">
            <MdMeetingRoom />
          </div>
          <h3>Room Scan Required</h3>
          <p>Please scan your room to ensure exam environment compliance:</p>
          <ul>
            <li>
              <MdCameraAlt /> Slowly pan your camera around the room
            </li>
            <li>
              <MdCameraAlt /> Show your desk and surrounding area
            </li>
            <li>
              <MdCameraAlt /> Complete a full 360-degree room view
            </li>
          </ul>
          <div className="room-scan-note">
            <p>This scan will automatically complete in 20 seconds</p>
            <p style={{ color: "#e74c3c", marginTop: "8px" }}>
              Room verification is mandatory to proceed with the exam.
            </p>
          </div>
          <div className="room-scan-actions">
            <button onClick={onStart} className="start-scan-btn">
              Start Room Scan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomScanDialog;
